import { createSlice } from "@reduxjs/toolkit";

export const CourtsSlice = createSlice({
  name: "courts",
  initialState: {
    courts: [],
  },
  reducers: {
    saveCourtsData: (state, action) => {
      state.courts = action.payload;
    }
  }
});

export const { saveCourtsData } = CourtsSlice.actions;
export default CourtsSlice.reducer;